import type { CardProps } from "antd";
import { Card, Flex, Typography } from "antd";
import type { FC, ReactNode } from "react";
import CountUp from "react-countup";

interface BaseStatisticCardProps extends CardProps {
    value: number;
    label: string;
    icon?: ReactNode;
    color?: string;
    suffix?: string;
}

/**
 * BaseStatisticCard - Reusable statistic card with CountUp animation
 */
export const BaseStatisticCard: FC<BaseStatisticCardProps> = ({ value, label, icon, color = "#000000", suffix = "", ...cardProps }) => {
    return (
        <Card {...cardProps} style={{ backgroundColor: "#FFFFFF", height: "100%", ...cardProps.style }}>
            <Flex vertical align="center" justify="center" gap="middle" style={{ height: "100%" }}>
                <Typography.Title level={2} style={{ margin: 0, color }}>
                    {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
                    <CountUp end={value} separator="," />
                    {suffix}
                </Typography.Title>
                <Typography.Text>{label}</Typography.Text>
            </Flex>
        </Card>
    );
};
